<template>
  <section>
    <div class="status"><h2 v-translate>Přiřazení operátoři</h2><h2>&nbsp;({{ entity.operators.length }})</h2></div>
    <form>
    <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="business-models-operators">
        <table class="vypis" ref="table_with_action_line">
      <not-sorting-table-header
          :titles="tableTitles"
          :useRight="false"
          :dragDrop="true"
          :checkbox="true"
      />
      <tbody>
      <operator-row
          v-for="entity in entity.operators"
          :entity="entity"
          :key="entity.id"
          :selectedEntities="selectedEntities"
          @input="select"
      />
      <tr v-if="!entity.operators || entity.operators.length === 0">
        <td colspan="3">{{ $gettext("Nebyly přiřazeni žádní operátoři.") }}</td>
      </tr>
      </tbody>
    </table>
      </div>
    </div>
    <local-list-action-line
        :entities="entity.operators"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        table-id="business-models-operators"
        @select-all="toggleSelectAll"
        @run-multiple-action="runMultipleAction"
    ></local-list-action-line>
    </form>
  </section>
</template>

<script>
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import localTable from "@/components/mixins/local-table"
import OperatorRow from "./OperatorRow";

	export default {
		name: "Operators",
    mixins: [localTable],
    components: {NotSortingTableHeader, OperatorRow},
		props: {
			entity: Object,
			errorMessages: {
				type: [Array, Object],
				default: function () {
					return []
				},
			},
		},
    computed:{
      tableTitles() {
        return [
          this.$gettext('Operátor'),
        ]
      },
      entities(){
        return Object.values(this.entity.operators);
      },
      csvHeaders() {
        return {
          'name': {name: this.$gettext('Operátor')},
        }
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/tabs/OperatorList.vue